/**
 * Calculates quorum status for a meeting
 * @param {Object} meetingSetup - Meeting configuration
 * @returns {Object} Quorum status with present flag, text, and details
 */
export const getQuorumStatus = (meetingSetup) => {
  if (!meetingSetup.totalMembers || !meetingSetup.presentMembers) {
    return { present: false, text: 'Quorum Unknown', details: 'Setup required' };
  }

  let requiredForQuorum;
  if (meetingSetup.quorumType === 'percentage') {
    requiredForQuorum = Math.ceil((meetingSetup.totalMembers * meetingSetup.quorumRequirement) / 100);
  } else {
    requiredForQuorum = meetingSetup.quorumRequirement;
  }

  const present = meetingSetup.presentMembers >= requiredForQuorum;
  return {
    present,
    text: present ? 'Quorum Present' : 'Quorum Not Present',
    details: `${meetingSetup.presentMembers}/${requiredForQuorum} required`,
    requiredForQuorum
  };
};